import * as service from "../service";

// NOTE: the `reviewFollowTaskAPI` wrapper for POST
// `api/sponsor/reviewTask/review/follow` was removed with the route itself.
// The route was unreachable (no caller in either client) and the worker branch
// behind it read a `postUrl` no client ever sent.

/**
 * Review a completed `ensure_followers` sponsor task.
 * Backend: POST /api/sponsor/reviewTask/review/ensure_followers
 */
export const reviewEnsureFollowersTaskAPI = async (payload: any) => {
  try {
    const resp = await service.call(
      "POST",
      "api/sponsor/reviewTask/review/ensure_followers",
      payload,
    );
    return resp;
  } catch (err) {
    console.error(`reviewEnsureFollowersTaskAPI ${err}`);
    throw err;
  }
};

/**
 * Review a completed `register_app` sponsor task.
 * Backend: POST /api/sponsor/reviewTask/review/register_app
 */
export const reviewRegisterAppTaskAPI = async (payload: any) => {
  try {
    const resp = await service.call(
      "POST",
      "api/sponsor/reviewTask/review/register_app",
      payload,
    );
    return resp;
  } catch (err) {
    console.error(`reviewRegisterAppTaskAPI ${err}`);
    throw err;
  }
};

/**
 * Review a completed `publish_story_post` sponsor task.
 * Backend: POST /api/sponsor/review/publish_story_post
 */
export const reviewPublishStoryPostTaskAPI = async (payload: any) => {
  try {
    const resp = await service.call(
      "POST",
      "api/sponsor/review/publish_story_post",
      payload,
    );
    return resp;
  } catch (err) {
    console.error(`reviewPublishStoryPostTaskAPI ${err}`);
    throw err;
  }
};

/**
 * Poll the job status of an `ensure_followers` review task.
 * Backend: GET /api/sponsor/reviewTask/review/ensure_followers/status
 */
export const reviewEnsureFollowersStatusAPI = async ({
  jobId,
  sponsorTaskCompletionId,
}: {
  jobId?: string;
  sponsorTaskCompletionId?: string;
}) => {
  try {
    const resp = await service.call(
      "GET",
      "api/sponsor/reviewTask/review/ensure_followers/status",
      {
        ...(jobId !== undefined ? { jobId } : {}),
        ...(sponsorTaskCompletionId !== undefined
          ? { sponsorTaskCompletionId }
          : {}),
      },
    );
    return resp;
  } catch (err) {
    console.error(`reviewEnsureFollowersStatusAPI ${err}`);
    throw err;
  }
};

/**
 * Upload image / video proof for a sponsor task completion.
 * Backend: POST /api/sponsor/reviewTask/review/upload_proof
 */
export const reviewUploadProofAPI = async (payload: any) => {
  try {
    const resp = await service.call(
      "POST",
      "api/sponsor/reviewTask/review/upload_proof",
      payload,
      { timeout: 30000 },
    );
    return resp;
  } catch (err) {
    console.error(`reviewUploadProofAPI ${err}`);
    throw err;
  }
};
